import { setAuthUser, refreshAuthUser } from '@/src/redux/slices/authSlice'
import { Dispatch } from 'redux'

export interface AuthUserData {
    signedIn: boolean
    email: string
    firstName: string
    lastName: string
    fullName: string
    userId?: string | number
    picture?: string
    googleId?: string
    ctAuth?: string
}

interface ProcessAuthResponseOptions {
    user: any;
    defaultEmail?: string;
    ctAuth?: string;
}

export const processAuthResponse = (response: any, dispatch: Dispatch, defaultEmail?: string): AuthUserData | null => {
    // Handle Google Sign-In response
    if (response?.user && 'googleId' in response.user) {
        const { user } = response;
        const authData: AuthUserData = {
            signedIn: true,
            email: user.email || defaultEmail || '',
            firstName: user.firstName || '',
            lastName: user.lastName || '',
            fullName: [user.firstName, user.lastName].filter(Boolean).join(' '),
            userId: user.userId || user.googleId,
            googleId: user.googleId,
            picture: user.picture,
            ctAuth: user.ctAuth
        };
        
        // First set the auth data from the response for immediate UI update
        dispatch(setAuthUser(authData));
        // Don't immediately refresh from cookies - let the caller handle timing
        // dispatch(refreshAuthUser());
        return authData;
    }

    // Handle regular auth response
    if (response?.user) {
        const { user } = response;
        const primaryTraveller =
            user.travellerDetails?.find((t: any) => t.personalDetails?.primaryEmail === user.username) ||
            user.travellerDetails?.[0];

        const firstName = primaryTraveller?.personalDetails?.firstName || '';
        const lastName = primaryTraveller?.personalDetails?.lastName || '';
        const email = user.username || defaultEmail || '';

        const authData: AuthUserData = {
            signedIn: true,
            email,
            firstName,
            lastName,
            fullName: [firstName, lastName].filter(Boolean).join(' '),
            userId: user.id,
            ctAuth: user.ctAuth
        };

        // First set the auth data from the response for immediate UI update
        dispatch(setAuthUser(authData));
        // Don't immediately refresh from cookies - let the caller handle timing
        // dispatch(refreshAuthUser());
        return authData;
    }

    return null;
}

export const clearAuthState = (dispatch: Dispatch) => {
    dispatch(
        setAuthUser({
            signedIn: false,
            email: undefined,
            firstName: undefined,
            lastName: undefined,
            fullName: undefined,
            userId: undefined,
            picture: undefined,
            googleId: undefined
        })
    )
}

export interface SignUpPayload {
    email: string
    password: string
    firstName: string
    lastName: string
    title: string
    marketingSubscription: boolean
}

export const constructSignUpPayload = (data: SignUpPayload): any => {
    return {
        usertitle: data.title,
        userfname: data.firstName,
        userlname: data.lastName,
        username: data.email,
        password: data.password,
        groupType: null,
        rewards: false,
        wallet: true,
        mkrtngSubscription: data.marketingSubscription ? 1 : 0,
        dm_type: typeof window !== 'undefined' ? window.location.host : ''
    }
}
